var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 65,
    viewBox: "0 0 190 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_273)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 65,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -27.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.6667,
    y: -27.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.3333,
    y: -27.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: -27.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.667,
    y: -27.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.6667,
    y: 14.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.3333,
    y: 14.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 14.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.667,
    y: 14.3333,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    y: 56,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.6667,
    y: 56,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.3333,
    y: 56,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 56,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.667,
    y: 56,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.667 -23.885V9.73568C166.667 12.2749 168.725 14.3334 171.264 14.3334H203.736C206.275 14.3334 208.333 16.3918 208.333 18.9311V51.4023C208.333 53.9416 210.392 56 212.931 56H245.402C247.942 56 250 58.0585 250 60.5977V93.069C250 95.6082 252.058 97.6667 254.598 97.6667H287.069C289.608 97.6667 291.667 99.7252 291.667 102.264V134.736C291.667 137.275 293.725 139.333 296.264 139.333H329.885M125 -23.885V9.73568C125 12.2749 127.058 14.3334 129.598 14.3334H162.069C164.608 14.3334 166.667 16.3918 166.667 18.9311V51.4023C166.667 53.9416 168.725 56 171.264 56H203.736C206.275 56 208.333 58.0585 208.333 60.5977V93.069C208.333 95.6082 206.275 97.6667 203.736 97.6667H171.264C168.725 97.6667 166.667 95.6082 166.667 93.069V60.023L166.626 59.7515C166.318 57.669 164.55 56.1141 162.446 56.0736L158.621 56H129.598C127.058 56 125 58.0585 125 60.5977V93.069C125 95.6082 127.058 97.6667 129.598 97.6667H162.356L163.448 97.7395C165.259 97.8602 166.667 99.3647 166.667 101.18V104.707M166.667 101.115V134.736C166.667 137.275 168.725 139.333 171.264 139.333H203.736C206.275 139.333 208.333 141.392 208.333 143.931V176.402C208.333 178.942 210.392 181 212.931 181H245.402C247.942 181 250 183.059 250 185.598V218.069C250 220.608 252.058 222.667 254.598 222.667H287.069C289.608 222.667 291.667 224.725 291.667 227.264V259.736C291.667 262.275 293.725 264.333 296.264 264.333H329.885",
    stroke: "url(#paint0_linear_125_273)",
    strokeOpacity: 0.8,
    strokeWidth: 0.431035
  }), /*#__PURE__*/React.createElement("rect", {
    y: 233.621,
    width: 233.621,
    height: 125,
    transform: "rotate(-90 0 233.621)",
    fill: "url(#paint1_linear_125_273)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.218,
    cy: -28.1608,
    rx: 155.46,
    ry: 132.471,
    fill: "url(#paint2_radial_125_273)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_273",
    x1: 125,
    y1: -23.885,
    x2: 325.287,
    y2: 223.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819437,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#12C2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#C471ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F64F59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_125_273",
    x1: 116.81,
    y1: 233.621,
    x2: 116.81,
    y2: 358.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_125_273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.218 -28.1608) rotate(90) scale(132.471 155.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBg);
export default __webpack_public_path__ + "static/media/logo-bg.6e7052d5ebe9814525815698db92593b.svg";
export { ForwardRef as ReactComponent };